// extracted by mini-css-extract-plugin
module.exports = {"Container":"ErrorSection_Container__3IdGr","TextsContainer":"ErrorSection_TextsContainer__X3_2-","Highlight":"ErrorSection_Highlight__2Sol1","Image":"ErrorSection_Image__3AZiB"};